import { JSONContent } from '@tiptap/core';

import { BORDER_STYLE_NONE } from 'global/constants';
import { getRichtextValue } from '../shared/logic/get-richtext-value';
import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import { ResponseFieldReadonly } from '../response/response-field-readonly.style';
import { ResponseBox } from '../response/response-view.style';
import { DISCUSSION_TEXT_RESPONSE_SETTINGS } from './discussion-view.constants';

const DiscussionTextResponseReadonly = ({
  baseHeight,
  answer,
}: {
  baseHeight: number;
  answer: JSONContent | null | undefined;
}) => {
  return (
    <ResponseBox variant={BORDER_STYLE_NONE}>
      <ResponseFieldReadonly
        $baseHeight={baseHeight}
        $numberOflines={1}
        dangerouslySetInnerHTML={{
          __html: getRichtextValue(
            answer,
            getExtensions(DISCUSSION_TEXT_RESPONSE_SETTINGS)
          ),
        }}
      />
    </ResponseBox>
  );
};

export default DiscussionTextResponseReadonly;
